import {observer} from "mobx-react";
import './drawer.scss';
import React, {ReactChild, useEffect} from "react";
import {createPortal} from "react-dom";
import IconDiscard from "../icons/icon-discard/icon-discard";
import {ButtonIcon} from "../inputs/button-icon/button-icon";
import appLayoutStore from "../../stores/app-layout-store";

export interface DrawerProps{
	closeButton?: {
		onClick: () => void
	},
	children?:ReactChild;
}
export const Drawer: React.FC<DrawerProps> = observer(({ closeButton = { onClick: () => { } }, children }) => {
    useEffect(() => {
        document.body.classList.add('no-scroll');
        return () => {
            document.body.classList.remove('no-scroll');
        }
    }, []);

    const drawerElementStyle = {
        top: appLayoutStore.headerHeight,
        height: appLayoutStore.headerHeight > 0 ? `calc(100% - ${appLayoutStore.headerHeight}px)` : '100%',
    }

	return createPortal(
		(
            <div className="drawer">
                <div className='drawer-overlay' onClick={closeButton?.onClick}/>
                <div className="drawer-element" style={drawerElementStyle}>
                    <div className='drawer-x'>
                        <ButtonIcon onClick={closeButton?.onClick} color='var(--color-neutral-3)' Component={IconDiscard}/>
                    </div>
                    <div className='drawer-content'>
                        {children}
                    </div>
                </div>
            </div>
		),
		document.body
	);
});

export default Drawer;